import serialize from 'serialize-javascript';

let __store__ = {
    user: null
};

function getKey(key){
    return typeof key === 'object' ? serialize(key) : key;
}

export default {

    set(key, val) {
        let _val = typeof val === 'object' ? serialize(val) : val;
        sessionStorage.setItem(getKey(key), _val);
        return val;
    },
    get(key){
        return JSON.parse(sessionStorage.getItem(getKey(key)));
    },
    remove(key) {
        let _key = getKey(key);
        delete __store__[_key];
        sessionStorage.removeItem(_key);
    },
    clear() {
        sessionStorage.clear();
    }
};
